import React from 'react';

import QuotaWinterSupervisors  from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaSupervisors/List.js';

export default function () {
  return <QuotaWinterSupervisors  />;
}
